<div class="animated fadeIn">
    <div class="p-2 ps-sm-3">
        <h3 class="ps-3 fw-sbold fs-28 pt-3">Obtén hasta 300%* en tu primer inversión</h3>
        <p class="ps-3 fs-16 mt-4 mt-md-0">A continuación te mostramos los resultados que puedes obtener, de acuerdo al monto <br> que ingresaste: <span class="cl-primary fw-bold">{{ amount | currency: '$'}}</span></p>
    </div>


    <div class="col-12 my-chart-container">
        <canvas id="myChart" class="m-auto d-block"></canvas>
    </div>


    <div class="months-benefiy d-flex align-items-center d-md-block m-auto pb-4">
        <div class="d-block m-auto d-md-flex align-items-center mt-3 col-6 col-md-12">
            <p class="cl-parrafe fw-bold col-12 col-md-2  text-center text-md-end text-end m-0 my-2 my-md-0">Meses</p>
            <div class="border d-block m-auto d-md-flex align-items-center justify-content-md-between col-10 col-md-8 p-0 p-md-2 ms-md-3">
                <p class="m-0 mx-2 text-center fs-14 fw-bold" *ngFor="let months of plans"  [ngClass]="{'highlighted': selectedPlan?.totalMonths === months.totalMonths}">{{ months.totalMonths }}</p>
            </div>
        </div>
        <div class="d-block m-auto d-md-flex align-items-center mt-3 col-6 col-md-12">
            <p class="cl-parrafe fw-bold col-12 col-md-2  text-center text-md-end text-end m-0 my-2 my-md-0">Bonificación</p>
            <div class="border d-block m-auto d-md-flex align-items-center justify-content-md-between col-10 col-md-8 p-0 p-md-2 ms-md-3 pb-2">
                <p class="m-0 mx-2 fs-13 text-center fw-bold" *ngFor="let months of plans" [ngClass]="{'highlighted': selectedPlan?.totalMonths === months.totalMonths}">${{ months.benefit | number: '1.0-0' }}</p>
            </div>
        </div>
    </div>


    <div class="details d-block m-auto d-md-flex justify-content-md-around pb-5">
        <div class="col-11 col-md-3 m-auto">
            <p class="fw-sbold cl-parrafe">Selecciona tu plan:</p>
            <div class="bg-white months border">
                <ul class="m-0 p-0">
                    <li *ngFor="let item of plans" 
                    class="cr-pointer cl-primary fw-sbold d-flex align-items-center" 
                    (click)="selectPlan(item)"
                    [ngStyle]="{'background-color': selectedPlan === item ? '#B8CFD6' : 'transparent'}" >
                        <span class="circle" [style.background-color]="getColor(item)"></span>
                        {{item.text}}
                    </li>
                </ul>
            </div>
            <div class="mt-5">
                <a href="#" class="cl-black text-decoration-underline">Términos y condiciones</a>
            </div>
        </div>
        <div class="col-11 col-md-7 m-auto">
            <p class="fw-sbold cl-parrafe">Resultados esperados con ese plan:</p>
            <div class="info border p-3">
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-parrafe">Inversión total:</p>
                    <p class="cl-parrafe fw-bold">{{ amountInit | currency: '$' }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-parrafe">Rendimiento acumulado*</p>
                    <p class="cl-parrafe fw-bold">{{ peformanceEstimate | currency: '$' }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-parrafe">Plusvalia acumulada*</p>
                    <p class="cl-parrafe fw-bold">{{ plusvaliaEstimate | currency: '$' }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-parrafe">Bonificación plan premium*</p>
                    <p class="cl-parrafe fw-bold">{{ benefitEstimate || 0 | currency: '$' }}</p>
                </div>
                <hr>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="fs-17 cl-parrafe fw-bold">Total estimado</p>
                    <p class="fs-17 cl-parrafe fw-bold cl-primary">{{ totalProfits || 0 | currency: '$' }} MXN</p>
                </div>
            </div>

            <button mat-button class="right mt-5" (click)="sendInfoPlanSelected()">Guardar</button>
        </div>
    </div>
</div>